import { TinyArea } from '@ant-design/charts'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { Col, Row, Table, Tooltip } from 'antd'
import { BLOCK_ICON } from 'Assets'
import { useDashboardMain } from 'Hooks/dashboardMain'
import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ChartCard, FooterCard } from '..'

const DashBoardStyled = styled.div`
  height: 475px;
`

export default function TopSearchDashboard() {
  const [trans] = useTranslation(['dashboard'])
  const { topSearch } = useDashboardMain()
  const [dataImpression, setDataImpression] = useState({
    impression: 0,
    impressionPercent: 0
  })
  const [dataImpressionChart, setDataImpressionChart] = useState([])
  const [dataSearchUserChart, setDataSearchUserChart] = useState([])
  const [dataSearchUser, setDataSearchUser] = useState({
    searchUsers: 0,
    searchUsersPercent: 0
  })
  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      render: (data, record, index) => index + 1
    },
    {
      title: `${trans('dashboard:page')}`,
      width: '70%',
      dataIndex: 'title',
      render: (data, record) => <div style={{ color: '#1890FF', fontWeight: '400' }}><div>{data}</div><div>{record.path}</div></div>
    },
    {
      title: `${trans('dashboard:views')}`,
      dataIndex: 'pageView'
    }
  ]

  const getConfigArea = (data, color, rest) => ({
    height: 44,
    width: 230,
    autoFit: true,
    data,
    smooth: true,
    areaStyle: {
      fill: color || '#975FE4',
      ...rest
    }
  })

  useEffect(() => {
    if (topSearch && topSearch?.data) {
      const dataTopSearch = topSearch.data
      const dataImpressionShow = {
        impression: dataTopSearch?.impression,
        impressionPercent: dataTopSearch?.prevImpression
          ? `${(
            ((dataTopSearch?.impression - dataTopSearch?.prevImpression)
                / dataTopSearch?.prevImpression)
              * 100
          ).toFixed(2)} %`
          : '---'
      }
      const dataSearchShow = {
        searchUsers: dataTopSearch?.searchUsers,
        searchUsersPercent: dataTopSearch?.prevSearchUsers
          ? `${(
            ((dataTopSearch?.searchUsers - dataTopSearch?.prevSearchUsers)
                / dataTopSearch?.prevSearchUsers)
              * 100
          ).toFixed(2)} %`
          : '---'
      }
      setDataImpression(dataImpressionShow)
      setDataSearchUser(dataSearchShow)

      const chartImpression = dataTopSearch?.impressionChart || []
      const chartSearch = dataTopSearch?.searchUsersChart || []
      if (chartImpression.length > 0) {
        const arrDataImpression = []
        for (let i = 0; i < chartImpression.length; i += 1) {
          arrDataImpression.push(chartImpression[i].value)
        }
        setDataImpressionChart(arrDataImpression)
      }
      if (chartSearch.length > 0) {
        const arrDataSearch = []
        for (let i = 0; i < chartSearch.length; i += 1) {
          arrDataSearch.push(chartSearch[i].value)
        }
        setDataSearchUserChart(arrDataSearch)
      }
    }
  }, [topSearch])
  return (
    <DashBoardStyled>
      <Row gutter={[48, 24]} style={{ marginBottom: '24px' }}>
        <Col sm={24} xl={12}>
          <div className="flex-center">
            <span className="text-size-14">{trans('dashboard:searchUsers')}</span>
            <Tooltip
              placement="topLeft"
              title={(
                <>
                  <div>Unique Visitors from Search</div>
                </>
              )}
            >
              <BLOCK_ICON />
            </Tooltip>
          </div>
          <div className="flex-center">
            <div className="text-size-24">
              {Intl.NumberFormat('en-US').format(dataSearchUser?.searchUsers || 0)}
            </div>
            <FooterCard>
              {dataSearchUser?.searchUsersPercent}
              <span
                style={{
                  display: dataSearchUser?.searchUsersPercent !== '---' ? 'inline' : 'none'
                }}
              >
                {dataSearchUser?.searchUsersPercent > 0 ? (
                  <CaretUpOutlined style={{ color: '#52C41A' }} />
                ) : (
                  <CaretDownOutlined style={{ color: 'red' }} />
                )}
              </span>
            </FooterCard>
          </div>
          <ChartCard>
            <TinyArea {...getConfigArea(dataSearchUserChart, '#D1E9FF')} />
          </ChartCard>
        </Col>
        <Col sm={24} xl={12}>
          <div className="flex-center">
            <span className="text-size-14">{trans('dashboard:perCapitaSearch')}</span>
            <Tooltip
              placement="topLeft"
              title={(
                <>
                  <div>The percentage of Visitors searching and impression</div>
                </>
              )}
            >
              <BLOCK_ICON />
            </Tooltip>
          </div>
          <div className="flex-center">
            <div className="text-size-24">
              {Intl.NumberFormat('en-US').format(Number(dataImpression?.impression || 0).toFixed(2))} %
            </div>
            <FooterCard>
              {dataImpression?.impressionPercent}
              <span
                style={{ display: dataImpression?.impressionPercent !== '---' ? 'inline' : 'none' }}
              >
                {dataImpression?.impressionPercent > 0 ? (
                  <CaretUpOutlined style={{ color: '#52C41A' }} />
                ) : (
                  <CaretDownOutlined style={{ color: 'red' }} />
                )}
              </span>
            </FooterCard>
          </div>
          <ChartCard>
            <TinyArea {...getConfigArea(dataImpressionChart, '#D1E9FF')} />
          </ChartCard>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            size="small"
            rowKey="path"
            columns={columns}
            dataSource={topSearch?.data?.topContents || []}
            pagination={
              {
                hideOnSinglePage: true
              }
            }
          />
        </Col>
      </Row>
    </DashBoardStyled>
  )
}
